import { IStoreState } from "../types";

export const getPaymentInfo = (state: IStoreState) => state.payment.paymentInfo;

export const getUserInfo = (state: IStoreState) => state.payment.userInfo;
export const getpaymentSuccess = (state: IStoreState) =>
  state.payment.getpaymentSuccess;
